const MAX_BOARD_PIXELS = 4000000;

// Apply the same memory budget to aiming, throws, and incoming-hit closeups.
export const getBoardPixelRatio = (width, height, deviceRatio) =>
  Math.min(
    deviceRatio || 1,
    3,
    Math.sqrt(MAX_BOARD_PIXELS / Math.max(1, width * height))
  );
